module.exports = __webpack_public_path__ + "static/snaptrip-tp-black-795e978e267a67d506c5971113853f82.svg";